/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum RequestTypeValueEnum {
    REIMBURSEMENT = 'Reimbursement',
    STIPEND = 'Stipend',
    TRAVEL = 'Travel',
}
